const rangeSelected = require('./rangeSelected');

module.exports = { rangeSelected };
